import { render, staticRenderFns } from "./ProjectsRanking.vue?vue&type=template&id=a08ff894"
import script from "./ProjectsRanking.vue?vue&type=script&lang=js"
export * from "./ProjectsRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports